import { useEffect, useState, useRef } from 'react'

// UI compoents
import Checkbox from '../../../../../ui/checkbox/checkbox'
import Input from '../../../../../ui/inputs/input'
import { TrashIcon } from '../../../../../../utils/svgs-v2'

// Returns the markup for the transfer items
export default function Transfer({ data, onUpdate, onDelete }) {
    const [ID, setID] = useState('')
    const [base, setBase] = useState(false)
    const [cost, setCost] = useState(null)
    const [location, setLocation] = useState(null)

    // Store a boolean for whether the component has been mounted
    const isMounted = useRef(false)

    // On component mount
    useEffect(() => {
        // Set the values into the state
        setID(data._id)
        setLocation(data.location)
        setCost(data.cost)
        setBase(data.base)

        // Then mark the isMounted flag as true
        isMounted.current = true
    }, [])

    // When any of the details are updated
    useEffect(() => {
        // Make sure we're mounted before processing any updates
        if (isMounted.current) {
            // Push the updates into the parent
            onUpdate({ _id: ID, location, cost, base })
        } else {
            // Otherwise mark it as mounted
            isMounted.current = true
        }
    }, [base, cost, location])

    return (
        <div className='price-window-room-type'>
            <Input 
                value={location}
                onChange={setLocation}
                placeholder='From location'
                showLabel={true} />

            <Input 
                value={cost}
                onChange={setCost}
                placeholder='Cost'
                showLabel={true} 
                symbol='£' />

            <Checkbox
                label='Include in base'
                checked={base}
                onClick={() => setBase(!base)} />

            <div className='price-window-target-delete' onClick={() => onDelete()}>
                <TrashIcon />
            </div>
        </div>
    )
}